import API from '@/views/Fdc/Apis/'
import Modal from '@/views/Fdc/EqpInfo/Components/Modal'

/**
 * EQP Info > Event Manager
 * Event 정보 관리
 */
export default {
  name: 'EventManager',
  components: {
    'modal': Modal // Edit / Add Modal
  },
  watch: {
  },
  beforeMount () {
    this.initColumns()
  },
  mounted () {
    // let self = this

    // /**
    //  * excel import function set
    //  */
    // document.getElementById('importFileInput').addEventListener('change', function () {
    //   let fileInput = document.getElementById('importFileInput')
    //   if (fileInput.files[0]) {
    //     if (fileInput.files[0].type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' &&
    //       fileInput.files[0].type !== 'application/vnd.ms-excel.sheet.macroEnabled.12') {
    //       self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.INFORM_NOT_VALID_FILE_EXTENSION', ['xlsx']))
    //       self.resetFileInput()
    //       return ''
    //     }

    //     let reader = new FileReader()
    //     reader.onload = function () {
    //       let workbook = new wjcXlsx.Workbook()
    //       workbook.loadAsync(reader.result, () => {
    //         let excelcell = workbook.sheets[0].rows[0]
    //         // Column 수 계산 (count로 계산)
    //         if (excelcell.cells.length === (self.eventManagerGrid.columns.length - 1)) {
    //           var count = 0
    //           // header 일치 여부 확인 (count로 계산)
    //           // row header column 빼고 계산
    //           for (var i = 0; i < self.eventManagerGrid.columns.length - 1; i++) {
    //             if (excelcell.cells[i].value === self.eventManagerGrid.columns[i + 1].header) {
    //               count++
    //             }
    //           }
    //           // header 일치 시 process start
    //           if (count === self.eventManagerGrid.columns.length - 1) {
    //             let newRowData = []
    //             for (let i = 0; i < workbook.sheets[0].rows.length - 1; i++) {
    //               let newRow = {}
    //               newRow.fab = workbook.sheets[0].rows[i + 1].cells[0].value.toString()
    //               newRow.eqpId = workbook.sheets[0].rows[i + 1].cells[1].value.toString()
    //               newRow.moduleId = workbook.sheets[0].rows[i + 1].cells[2].value.toString()

    //               newRow.ceid = workbook.sheets[0].rows[i + 1].cells[3].value.toString()
    //               newRow.eventType = workbook.sheets[0].rows[i + 1].cells[4].value.toString()
    //               newRow.eventName = workbook.sheets[0].rows[i + 1].cells[5].value.toString()
    //               newRow.eventDesc = workbook.sheets[0].rows[i + 1].cells[6].value.toString()
    //               newRow.useYn = workbook.sheets[0].rows[i + 1].cells[7].value.toString()
    //               newRow.startYn = workbook.sheets[0].rows[i + 1].cells[8].value.toString()
    //               newRow.virtualYn = workbook.sheets[0].rows[i + 1].cells[9].value.toString()

    //               newRow.isNew = true
    //               newRow['_status'] = {}
    //               newRow['_status']['checked'] = true
    //               newRow['_status']['added'] = true
    //               newRow['_status']['modified'] = false
    //               newRowData.push(newRow)
    //             }
    //             self.rowData = newRowData
    //             self.resetFileInput()
    //           } else {
    //             self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.INFORM_NOT_VALID_COLUMN'))
    //             self.resetFileInput()
    //           }
    //         } else {
    //           self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.INFORM_NOT_VALID_COLUMN'))
    //           self.resetFileInput()
    //         }
    //       })
    //     }
    //     reader.readAsDataURL(fileInput.files[0])
    //   }
    // })
  },
  methods: {
    /**
     * Column initialize
     */
    initColumns () {
      this.columns = [
        { headerName: this.$t('fdc.COMMON.COLUMN.FAB'), field: 'fab', hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.EQP_ID'), field: 'eqpId', hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODULE_ID'), field: 'moduleId', hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.CEID'), field: 'ceid', width: 120, required: true, checkboxSelection: true, headerCheckboxSelection: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.EVENT_TYPE'), field: 'eventType', width: 120, required: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.EVENT_NAME'), field: 'eventName', width: 110, required: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.USABLE'), field: 'useYn', width: 90, required: true, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.START_EVENT'), field: 'startYn', width: 110, required: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.VIRTUAL'), field: 'virtualYn', width: 100, required: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.DESCRIPTION'), field: 'eventDesc', width: 150 },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODIFY_TIME'), field: 'modifyDt', width: 160, type: 'dateTimeColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODIFY_USER'), field: 'modifyUser', width: 110 }
      ]
    },
    /**
     * Event Manager 목록 조회
     * @param {String} fab Fab
     * @param {String} eqpId EQP ID
     * @param {String} moduleId Module ID
     */
    async listFn (fab, eqpId, moduleId) {
      let payload = {
        fab: fab,
        eqpId: eqpId,
        moduleId: moduleId
      }
      let data = await API.BaseInfo.getEqpEvents(payload)
      this.rowData = data
      // this.eventManagerGrid.select(-1, -1)
    },
    /**
     * EQP Tree select시 수행하는 method
     * @param {Object} node 선택된 tree node data
     */
    eqpTreeSelected (node) {
      this.selectedTreeNode = node
    },
    /**
     * Event 검색
     */
    searchProcess () {
      if (this.selectedTreeNode.length === 0) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Equipment']))
        return
      }
      let node = this.selectedTreeNode
      if (node.detail.moduleId === '') {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Module ID']))
        return
      }
      this.searchTreeNode = this.selectedTreeNode

      this.$commonUtil.setStoreEqpTree(
        this.selectedTreeNode,
        this.$refs.fdcEqpTree.treeType
      )

      this.listFn(
        node.detail.fab,
        node.detail.eqpId,
        node.detail.moduleId
      )
    },
    /**
     * Event Manager Grid에 check된 row count 확인
     * @returns {Boolean} check된 row가 있는지 여부
     */
    hasCheckedRows () {
      if (!this.$refs.eventManagerGrid) {
        return 0
      }
      return this.$refs.eventManagerGrid.checkedRowCount > 0
    },
    /**
     * Add Button 활성화 여부 결정
     * @returns {Boolean} Add Button 활성화 여부
     * 검색된 tree node 있는지 여부를 판단하여 Add Button 활성화 여부를 결정합니다.
     */
    addEnable () {
      if (!this.searchTreeNode.detail) {
        return false
      } else {
        let selectEqpVo = this.searchTreeNode.detail
        if (selectEqpVo.fab !== null &&
          selectEqpVo.eqpId !== null &&
          selectEqpVo.moduleId !== null) {
          return true
        }
        return false
      }
    },
    /**
     * Event Add Modal 열기
     */
    openAddModal () {
      this.eventSaveModal.visible = true
      this.modalTitle = this.$t('fdc.EQP_INFO.TITLE.T0022')
      this.initAddEventModal()
    },
    // updateComboBoxInGrid () {
    //   if (this.eventManagerGrid) {
    //     let colEventType = this.eventManagerGrid.columns.getColumn('eventType')
    //     if (colEventType) {
    //       colEventType.dataMapEditor = true
    //       colEventType.dataMap = this.buildDataMap2(this.eventTypeList)
    //     }
    //     let colUseYn = this.eventManagerGrid.columns.getColumn('useYn')
    //     if (colUseYn) {
    //       colUseYn.dataMapEditor = true
    //       colUseYn.dataMap = this.buildDataMap(this.useYnList, 'useYn')
    //     }
    //     let colStartYn = this.eventManagerGrid.columns.getColumn('startYn')
    //     if (colStartYn) {
    //       colStartYn.dataMapEditor = true
    //       colStartYn.dataMap = this.buildDataMap(this.startYnList, 'startYn')
    //     }
    //     let colVirtualYn = this.eventManagerGrid.columns.getColumn('virtualYn')
    //     if (colVirtualYn) {
    //       colVirtualYn.dataMapEditor = true
    //       colVirtualYn.dataMap = this.buildDataMap(this.virtualYnList, 'virtualYn')
    //     }
    //   }
    // },
    // async getCodeList (type) {
    //   var payload = {
    //     codeType: type
    //   }
    //   var data = await API.FdcEqpInfo.getCodeList(payload)
    //   if (type === 'eventType') {
    //     this.eventTypeList = data
    //   }
    // },
    // buildDataMap (items, keyName) {
    //   let map = []
    //   for (let i = 0; i < items.length; i++) {
    //     map.push({ key: items[i][keyName], value: items[i][keyName] })
    //   }
    //   return new wjcGrid.DataMap(map, 'key', 'value')
    // },
    // buildDataMap2 (items) {
    //   let map = []
    //   for (let i = 0; i < items.length; i++) {
    //     map.push({ key: items[i], value: items[i] })
    //   }
    //   return new wjcGrid.DataMap(map, 'key', 'value')
    // },
    /**
     * Event Manager Grid 재조회
     */
    refreshGrid () {
      if (this.searchTreeNode && this.searchTreeNode.length !== 0) {
        let selectEqpVo = this.searchTreeNode.detail
        this.listFn(selectEqpVo.fab, selectEqpVo.eqpId, selectEqpVo.moduleId)
      }
    },
    // async cellEditEnd (grid, event) {
    //   let col = grid.columns[event.col]
    //   let rowData = grid.rows[event.row]._data
    //   let rowStatus = grid.rows[event.row]._data._status

    //   // modified and added row 시 자동 check (checkbox column 제외)
    //   if (col.binding !== '_status.checked') {
    //     if (rowStatus.modified || rowStatus.added) {
    //       rowStatus.checked = true
    //     }
    //     // else {
    //     //   rowStatus.checked = false
    //     // }
    //   }

    //   // key validation
    //   if (rowData.isNew && rowData.eqpId && rowData.moduleId && rowData.ceid) {
    //     if (col.binding === 'ceid') {
    //       let payload = {
    //         fab: rowData.fab,
    //         eqpId: rowData.eqpId,
    //         moduleId: rowData.moduleId,
    //         ceid: rowData.ceid
    //       }

    //       let result = await API.FdcEqpInfo.eventKeyValidation(payload)
    //       if (result > 0) {
    //         this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_KEY_DUPLICATED', ['KEY']))
    //         rowData.ceid = null
    //       } else {
    //         if (!this.newRowsKeyValidation(payload)) {
    //           this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_KEY_DUPLICATED', ['KEY']))
    //           rowData.ceid = null
    //         }
    //       }
    //     }
    //   }
    // },
    /**
     * Event 삭제
     * 실제 삭제가 아니라 Use YN만 'N'으로 변경합니다.
     */
    async deleteData () {
      let self = this
      // let checkedRows = this.$refs.eventManagerGrid.checkedRows
      // let allRows = this.$refs.eventManagerGrid.grid.rows
      // let checkedRows = common.getCheckedRows(allRows)
      const checkedRows = this.$refs.eventManagerGrid.gridApi.getSelectedRows()

      if (checkedRows < 1) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Item']))
        return
      }

      let mustDeleteRows = []

      for (let i in checkedRows) {
        let isCreate = true
        if (!checkedRows[i].isNew) {
          isCreate = false
        }
        // var data = _.clone(checkedRows[i])
        // delete data['_status']
        var data = checkedRows[i]
        if (!isCreate) {
          mustDeleteRows.push(data)
        }
      }

      let message = (mustDeleteRows.length) + ' ' + this.$t('fdc.COMMON.MESSAGE.CONFIRM_MULTI_DELETE')

      this.$dialog.confirm({
        message: message,
        cancelText: this.$t('fdc.COMMON.BUTTON.CANCEL'),
        confirmText: this.$t('fdc.COMMON.BUTTON.CONFIRM'),
        onConfirm: function () {
          function deleteLastProcess (response) {
            if (response != null && response.status === 200) {
              self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.SUCCEED_DELETE'))
              let node = self.searchTreeNode
              self.listFn(node.detail.fab, node.detail.eqpId, node.detail.moduleId)
            } else {
              self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.FAILED_DELETE'))
            }
          }

          if (mustDeleteRows.length > 0) {
            API.BaseInfo.putEqpEvent(mustDeleteRows).then(result => {
              deleteLastProcess(result)
            })
          }
        },
        onCancel: function () {}
      })
    },
    // newRowsKeyValidation (params) {
    //   let allRows = this.$refs.eventManagerGrid.grid.rows
    //   let addedRows = common.getAddedRows(allRows)
    //   let result = true
    //   let sameDataCnt = 0
    //   for (var i in addedRows) {
    //     if (addedRows[i].fab === params.fab &&
    //       addedRows[i].eqpId === params.eqpId &&
    //       addedRows[i].moduleId === params.moduleId &&
    //       addedRows[i].ceid === params.ceid &&
    //       addedRows[i].ceid) {
    //       // result = false
    //       // break
    //       sameDataCnt++
    //     }
    //   }
    //   if (sameDataCnt > 1) {
    //     result = false
    //   }
    //   return result
    // },
    /**
     * Excel Export
     * 조회된 결과를 Excel 파일로 저장합니다.
     */
    exportExcel () {
      // this.$refs.eventManagerGrid.exportExcel('EventManager')
      this.$refs.eqpManagerGrid.gridApi.exportDataAsCsv({
        fileName: 'EventManager.csv'
      })
    },
    /**
     * Excel Import
     * excel을 import 할 수 있도록 파일 선택창을 띄웁니다.
     */
    importExcel () {
      this.resetFileInput()
      document.getElementById('importFileInput').click()
    },
    /**
     * File value 초기화
     * 선택된 파일을 초기화 합니다.
     */
    resetFileInput () {
      document.getElementById('importFileInput').value = ''
    },
    /**
     * Event Edit Modal 열기
     */
    editRow () {
      this.eventSaveModal.visible = true
      this.modalTitle = this.$t('fdc.EQP_INFO.TITLE.T0021')
      this.initEditEventModal()
    },
    /**
     * Event Edit Modal 초기 data 설정
     */
    initEditEventModal () {
      // const rows = this.$refs.eventManagerGrid.grid.rows.filter(row => row.dataItem._status)
      // const checkedRowData = rows.find(row => row.dataItem._status.checked).dataItem
      // checkedRowData.saveType = 'Edit'
      const checkedRowData = this.$refs.eventManagerGrid.getCheckedRows()[0]
      checkedRowData.saveType = 'Edit'
      this.initValue = Object.assign({}, checkedRowData)
    },
    /**
     * Event Add Modal 초기 data 설정
     */
    initAddEventModal () {
      let data = this.searchTreeNode.detail
      this.initValue = {
        saveType: 'Add',
        fab: data.fab,
        eqpId: data.eqpId,
        moduleId: data.moduleId
      }
    },
    /**
     * Event Add/Edit Modal close
     */
    closeEventSaveModal () {
      this.eventSaveModal.visible = false
    },
    /**
     * Event Add/Edit Modal data 초기화
     */
    resetEventModalInitValue () {
      this.initValue = {}
    },
    /**
     * Event Manager Grid에 check된 row count가 1개인지 확인
     * @returns {Boolean} check된 1개인지 여부
     * Edit 가능 여부에 대해서 판단하여 button 활성화 값이 달라집니다.
     */
    hasOneCheckedRow () {
      if (!this.$refs.eventManagerGrid) {
        return 0
      }
      return this.$refs.eventManagerGrid.checkedRowCount === 1
    },
    /**
     * Edit Button click event
     * check된 row가 없는 상태에서 click 시 alert를 띄웁니다.
     */
    clickDisabledEditButton () {
      if (this.$refs.eventManagerGrid.checkedRowCount !== 1) {
        this.$dialog.alert('Check a row to edit Event')
      }
    }
  },
  data () {
    return {
      eventManagerGrid: null, // Event Manager Grid 객체
      // columns: [
      //   { label: this.$t('fdc.COMMON.COLUMN.FAB'), binding: 'fab', visible: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.EQP_ID'), binding: 'eqpId', visible: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.MODULE_ID'), binding: 'moduleId', visible: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.CEID'), binding: 'ceid', width: 90, required: true, modifiable: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.EVENT_TYPE'), binding: 'eventType', width: 120, required: true, modifiable: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.EVENT_NAME'), binding: 'eventName', width: 110, required: true, modifiable: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.USABLE'), binding: 'useYn', width: 90, required: true, modifiable: false, visible: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.START_EVENT'), binding: 'startYn', width: 110, required: true, modifiable: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.VIRTUAL'), binding: 'virtualYn', width: 100, required: true, modifiable: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.DESCRIPTION'), binding: 'eventDesc', width: 150, modifiable: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.MODIFY_TIME'), binding: 'modifyDt', width: 160, readOnly: true, dataType: 'Date', format: 'yyyy-MM-dd HH:mm:ss' },
      //   { label: this.$t('fdc.COMMON.COLUMN.MODIFY_USER'), binding: 'modifyUser', width: 110, readOnly: true }
      // ], // grid column 배열
      columns: [], // grid column 배열
      defaultColDef: {
        minWidth: 100,
        filter: true,
        sortable: true,
        resizable: true
      }, // BRIQUE Grid column default setting
      rowData: [], // grid row data
      selectedTreeNode: [], // 선택된 EQP Tree node
      searchTreeNode: [], // 검색한 EQP Tree node
      eventTypeList: [], // Event Type Data Map 배열
      // useYnList: [
      //   { useYn: 'Y' },
      //   { useYn: 'N' }
      // ],
      // startYnList: [
      //   { startYn: 'Y' },
      //   { startYn: 'N' }
      // ],
      // virtualYnList: [
      //   { virtualYn: 'Y' },
      //   { virtualYn: 'N' }
      // ],
      modalTitle: '', // Event Save Modal Title
      initValue: {}, // Event Save Modal 초기 data
      eventSaveModal: {
        visible: false
      } // Event Save Modal 표시 여부
    }
  }
}
